import { type ReactNode } from "react";
import RoundedCard from "@cle/components/RoundedCard";
import DocumentStatusBadge from "./DocumentStatusBadge";

type CourseCertificateInfoCardProps = {
  action?: ReactNode;
  isReported: boolean;
  statusLabel: string;
  statusVariant: "danger" | "info" | "success" | "warning";
  title: string;
  uploadedAt: string;
};

const CourseCertificateInfoCard = ({
  action,
  isReported,
  statusLabel,
  statusVariant,
  title,
  uploadedAt,
}: CourseCertificateInfoCardProps) => {
  return (
    <RoundedCard
      className="cle-course-certificate-document__side-card"
      header="Information"
      action={action}
    >
      <dl className="cle-course-certificate-document__info-list mb-0">
        <dt>Dokument</dt>
        <dd>{title}</dd>

        <dt>Type</dt>
        <dd>Kursusbevis</dd>

        <dt>Status</dt>
        <dd className="d-flex flex-wrap gap-2">
          <DocumentStatusBadge variant={statusVariant}>
            {statusLabel}
          </DocumentStatusBadge>
          {isReported ? (
            <DocumentStatusBadge variant="primary">
              Indberettet
            </DocumentStatusBadge>
          ) : null}
        </dd>

        <dt>Uploadet den</dt>
        <dd>{uploadedAt}</dd>
      </dl>
    </RoundedCard>
  );
};

export default CourseCertificateInfoCard;
